import type { ReceiptTemplate } from '../schema';

export const gmailTemplate: ReceiptTemplate = {
  id: 'gmail',
  name: 'Gmail Receipt',
  brand: 'GOOGLE',
  description: 'Google Workspace receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'gm-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'GOOGLE WORKSPACE',
        businessNameFontSize: 14,
        addressLines: ['PAYMENT RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gm-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: 'GWS-847291034' },
          { id: 'account', label: 'Account:', value: 'john@company.com' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'type', label: 'Type:', value: 'Annual' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gm-plan',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'PLAN: Business Standard\nUSERS: 5\nSTORAGE: 2TB per user', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'gm-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'sub', label: 'SUBSCRIPTION', value: '720.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '59.40', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '779.40', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gm-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'gm-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PAYMENT SUCCESSFUL', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: true },
    },
  ],
  updatedAt: new Date().toISOString(),
};

